import { render, staticRenderFns } from "./RsaConfigurazioneTurniListPage.vue?vue&type=template&id=af593750"
import script from "./RsaConfigurazioneTurniListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneTurniListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports